export default class SalesByProductsController {
  constructor(ContentService, isMobile, moment) {
    this.service = ContentService;
    this.isMobile = isMobile;
    this.moment = moment;
  }

  $onInit(){
    this.subscriptions = [];

    this.inMobileView = this.isMobile.phone;
    this.dateFrom = undefined;
    this.dateTo = undefined;
    this.filter = '';
    this.articles = [];
  }
  $onDestroy() {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  findSalesByProducts() {
    this.subscriptions.push(
      this.service.findSalesByProducts({
        date_from: this.dateFrom.format(),
        date_to: this.dateTo.format(),
      }).subscribe(
        (articles) => this.articles = articles,
        (err) => console.log(err)
      )
    );
  }

  getTotal(item) { return item.total_billed; }
  getDiscount(item) { return item.discount_billed; }
  getOth(item) { return item.oth_total; }
  getVoid(item) { return item.cancelation_total; }
  getReturned(item) { return item.return_total; }

}

 SalesByProductsController.$inject = ['ContentService', 'isMobile', 'moment'];


// WEBPACK FOOTER //
// ./src/app/pages/sales-by-products/sales-by-products.controller.js